export const CTABannerRefName = 'CTABannerRef';

export const CTABannerRefProjection = `{
  _id,
  title,
  subtitle,
  imageBackground,
  textAlignment,
  cta,
}`;

export const CTABannerRefQuery = groq`*[_id == $_id && _type == "CTABanner"][0] ${CTABannerRefProjection}`;
